import z from "zod";
import { PlaceOfWorkSchema } from "./place-of-work-dto";

export const ProfessionSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable().optional(),
    placesOfWork: z.array(PlaceOfWorkSchema),
});
export type ProfessionDTO = z.infer<typeof ProfessionSchema>;

export const ProfessionOptimizedSchema = z.object({
    id: z.string(),
    name: z.string(),
    placesOfWork: z.array(PlaceOfWorkSchema),
});
export type ProfessionOptimizedDTO = z.infer<typeof ProfessionSchema>;
